"use client";

import React from "react";
import { UniversalEntityPage } from "../UniversalEntityPage";
import type { BaseEntity, SimpleTableConfig, EntityHooks } from "../UniversalCRMTable/types";

interface EntityListProps<T extends BaseEntity> {
  entityName: string;
  config: SimpleTableConfig<T>;
  hooks: EntityHooks<T>;
  filters?: Record<string, any>;
  storageKey?: string;
  title?: string;
  description?: string;
  showHeader?: boolean;
  customComponents?: any;
}

function EntityListComponent<T extends BaseEntity>({
  entityName,
  config,
  hooks,
  filters,
  storageKey,
  title,
  description,
  showHeader = true,
  customComponents,
}: EntityListProps<T>) {
  return (
    <UniversalEntityPage
      entityName={entityName}
      config={config}
      hooks={hooks}
      filterPreset="all"
      customFilters={filters}
      storageKey={storageKey}
      title={title}
      description={description}
      showHeader={showHeader}
      customComponents={customComponents}
    />
  );
}

export const EntityList = React.memo(EntityListComponent) as typeof EntityListComponent;
